export const cx = (...args: (string | false | null | undefined)[]): string => args.filter(Boolean).join(' ');
